
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexaVisg5W9k1Meta } from "/codebuild/output/src2386790677/src/pages/index.vue?macro=true";
import { default as aboutMX2Wi4rUxJMeta } from "/codebuild/output/src2386790677/src/pages/about.vue?macro=true";
import { default as datavnackTBTwIMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionzuI2lwlKTDMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningQjWCR1zXhKMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyCvS5ADfYrqMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountOjcMF3TwZdMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueayOtZSWAkDMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/statue.vue?macro=true";
import { default as supportLS22XfgDSSMeta } from "/codebuild/output/src2386790677/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsSn7S9DKxv4Meta } from "/codebuild/output/src2386790677/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountbLfHMfjWm1Meta } from "/codebuild/output/src2386790677/src/pages/activate-account.vue?macro=true";
import { default as companyNPNhARs15hMeta } from "/codebuild/output/src2386790677/src/pages/admin/company.vue?macro=true";
import { default as consentscReg94ylqUMeta } from "/codebuild/output/src2386790677/src/pages/admin/consents.vue?macro=true";
import { default as leads3uq13rPaKEMeta } from "/codebuild/output/src2386790677/src/pages/admin/leads.vue?macro=true";
import { default as paymentsmXDK3jqje7Meta } from "/codebuild/output/src2386790677/src/pages/admin/payments.vue?macro=true";
import { default as premiumjz6YwKEKpaMeta } from "/codebuild/output/src2386790677/src/pages/admin/premium.vue?macro=true";
import { default as profilesavCDEEmaqSMeta } from "/codebuild/output/src2386790677/src/pages/admin/profiles.vue?macro=true";
import { default as userseNsVOKxrz0Meta } from "/codebuild/output/src2386790677/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordH98e7z4yjMMeta } from "/codebuild/output/src2386790677/src/pages/change-password.vue?macro=true";
import { default as _91id_93MXFDVZZ15mMeta } from "/codebuild/output/src2386790677/src/pages/chat/[id].vue?macro=true";
import { default as aindBd1msWsiMeta } from "/codebuild/output/src2386790677/src/pages/chat/ai.vue?macro=true";
import { default as index0z290JVJ1pMeta } from "/codebuild/output/src2386790677/src/pages/chat/index.vue?macro=true";
import { default as chatufWdj6b2uHMeta } from "/codebuild/output/src2386790677/src/pages/chat.vue?macro=true";
import { default as _91id_93KJBf7KoqAGMeta } from "/codebuild/output/src2386790677/src/pages/client/profile/[id].vue?macro=true";
import { default as indexsT5TEIFvzZMeta } from "/codebuild/output/src2386790677/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93y73PHqvYuOMeta } from "/codebuild/output/src2386790677/src/pages/contacts/[id].vue?macro=true";
import { default as indexP8a0MyJBszMeta } from "/codebuild/output/src2386790677/src/pages/contacts/index.vue?macro=true";
import { default as contactsFRuo8rHoWkMeta } from "/codebuild/output/src2386790677/src/pages/contacts.vue?macro=true";
import { default as _91userId_93GfTj36omLEMeta } from "/codebuild/output/src2386790677/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as index8fk6hQtw9vMeta } from "/codebuild/output/src2386790677/src/pages/login/index.vue?macro=true";
import { default as register_45successIov98UKYiVMeta } from "/codebuild/output/src2386790677/src/pages/login/register-success.vue?macro=true";
import { default as loginmbNp9ltFlPMeta } from "/codebuild/output/src2386790677/src/pages/login.vue?macro=true";
import { default as logoutJ2DBjVKtWvMeta } from "/codebuild/output/src2386790677/src/pages/logout.vue?macro=true";
import { default as consentsi2rccBC3GCMeta } from "/codebuild/output/src2386790677/src/pages/manager/consents.vue?macro=true";
import { default as integrations9elJY8uiTpMeta } from "/codebuild/output/src2386790677/src/pages/manager/integrations.vue?macro=true";
import { default as leadsylwbwzsK9mMeta } from "/codebuild/output/src2386790677/src/pages/manager/leads.vue?macro=true";
import { default as paymentsN3X5Vep3U8Meta } from "/codebuild/output/src2386790677/src/pages/manager/payments.vue?macro=true";
import { default as profileZhQehJYPXMMeta } from "/codebuild/output/src2386790677/src/pages/manager/profile.vue?macro=true";
import { default as teamxwVLqyyipvMeta } from "/codebuild/output/src2386790677/src/pages/manager/team.vue?macro=true";
import { default as indextlShU1mhWIMeta } from "/codebuild/output/src2386790677/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46client1OzB8bAzQHMeta } from "/codebuild/output/src2386790677/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src2386790677/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplacelCY9dbPynZMeta } from "/codebuild/output/src2386790677/src/pages/marketplace.vue?macro=true";
import { default as subscribe3XoCX3Jl8pMeta } from "/codebuild/output/src2386790677/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientTby7TP2AWOMeta } from "/codebuild/output/src2386790677/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientNkB8qZqAhwMeta } from "/codebuild/output/src2386790677/src/pages/orders/my.client.vue?macro=true";
import { default as privacyF0xNDXLHekMeta } from "/codebuild/output/src2386790677/src/pages/privacy.vue?macro=true";
import { default as index9ByWU2UY7gMeta } from "/codebuild/output/src2386790677/src/pages/recover/index.vue?macro=true";
import { default as success0WWtROjHrRMeta } from "/codebuild/output/src2386790677/src/pages/register/success.vue?macro=true";
import { default as _91id_93GggnFOvXOJMeta } from "/codebuild/output/src2386790677/src/pages/sales/profile/[id].vue?macro=true";
import { default as indexTafZKIM13AMeta } from "/codebuild/output/src2386790677/src/pages/sales/profile/index.vue?macro=true";
import { default as statueTX24FwG6s6Meta } from "/codebuild/output/src2386790677/src/pages/statue.vue?macro=true";
import { default as successSdUNt3WHttMeta } from "/codebuild/output/src2386790677/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubmmaxsHCWwnMeta } from "/codebuild/output/src2386790677/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmmaxsHCWwn } from "/codebuild/output/src2386790677/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexaVisg5W9k1Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutMX2Wi4rUxJMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutMX2Wi4rUxJMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsSn7S9DKxv4Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsSn7S9DKxv4Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src2386790677/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountbLfHMfjWm1Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountbLfHMfjWm1Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyNPNhARs15hMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyNPNhARs15hMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentscReg94ylqUMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentscReg94ylqUMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leads3uq13rPaKEMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leads3uq13rPaKEMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsmXDK3jqje7Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsmXDK3jqje7Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumjz6YwKEKpaMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumjz6YwKEKpaMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesavCDEEmaqSMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesavCDEEmaqSMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: userseNsVOKxrz0Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: userseNsVOKxrz0Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordH98e7z4yjMMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordH98e7z4yjMMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/change-password.vue")
  },
  {
    name: chatufWdj6b2uHMeta?.name,
    path: "/en/chat",
    meta: chatufWdj6b2uHMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93MXFDVZZ15mMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aindBd1msWsiMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: index0z290JVJ1pMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatufWdj6b2uHMeta?.name,
    path: "/pl/chat",
    meta: chatufWdj6b2uHMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93MXFDVZZ15mMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aindBd1msWsiMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: index0z290JVJ1pMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_93KJBf7KoqAGMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_93KJBf7KoqAGMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexsT5TEIFvzZMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexsT5TEIFvzZMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/client/profile/index.vue")
  },
  {
    name: contactsFRuo8rHoWkMeta?.name,
    path: "/en/contacts",
    meta: contactsFRuo8rHoWkMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93y73PHqvYuOMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexP8a0MyJBszMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsFRuo8rHoWkMeta?.name,
    path: "/pl/contacts",
    meta: contactsFRuo8rHoWkMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93y73PHqvYuOMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexP8a0MyJBszMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93GfTj36omLEMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93GfTj36omLEMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexaVisg5W9k1Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexaVisg5W9k1Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/index.vue")
  },
  {
    name: loginmbNp9ltFlPMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src2386790677/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: index8fk6hQtw9vMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successIov98UKYiVMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginmbNp9ltFlPMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src2386790677/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: index8fk6hQtw9vMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successIov98UKYiVMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutJ2DBjVKtWvMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutJ2DBjVKtWvMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsi2rccBC3GCMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsi2rccBC3GCMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrations9elJY8uiTpMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrations9elJY8uiTpMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsylwbwzsK9mMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsylwbwzsK9mMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsN3X5Vep3U8Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsN3X5Vep3U8Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileZhQehJYPXMMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileZhQehJYPXMMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamxwVLqyyipvMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamxwVLqyyipvMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/manager/team.vue")
  },
  {
    name: marketplacelCY9dbPynZMeta?.name,
    path: "/en/marketplace",
    meta: marketplacelCY9dbPynZMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src2386790677/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46client1OzB8bAzQHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplacelCY9dbPynZMeta?.name,
    path: "/pl/marketplace",
    meta: marketplacelCY9dbPynZMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src2386790677/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46client1OzB8bAzQHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribe3XoCX3Jl8pMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribe3XoCX3Jl8pMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientTby7TP2AWOMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientTby7TP2AWOMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientNkB8qZqAhwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientNkB8qZqAhwMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src2386790677/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyF0xNDXLHekMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyF0xNDXLHekMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: index9ByWU2UY7gMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: index9ByWU2UY7gMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src2386790677/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src2386790677/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93GggnFOvXOJMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93GggnFOvXOJMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: indexTafZKIM13AMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: indexTafZKIM13AMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueTX24FwG6s6Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueTX24FwG6s6Meta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successSdUNt3WHttMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successSdUNt3WHttMeta || {},
    component: () => import("/codebuild/output/src2386790677/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubmmaxsHCWwnMeta?.name,
    path: "/old-page",
    component: component_45stubmmaxsHCWwn
  }
]